<vi-panel>
  <div content class="flex flex-row justify-between items-center">
    <h3>
      {{
        (isFlatRate ? '+USER_DETAILS.FLAT_RATE.TITLE' : '+USER_DETAILS.BOOKINGS.TITLE') | translate
      }}
    </h3>
  </div>
</vi-panel>

<ng-container *ngIf="bookingStore.subscriptions$ | async as subscriptions">
  <ng-container *ngIf="bookingStore.loaded$ | async">
    <ng-container *ngIf="subscriptions.length">
      <app-package-per-installation-bookings
        *ngIf="!isFlatRate; else flatRateBookings"
        [subscriptions]="subscriptions"
      ></app-package-per-installation-bookings>
      <ng-template #flatRateBookings>
        <app-flat-rate-bookings [subscriptions]="subscriptions"></app-flat-rate-bookings>
      </ng-template>
    </ng-container>
  </ng-container>

  <vi-panel *ngIf="(bookingStore.loaded$ | async) && subscriptions.length === 0">
    <div content class="flex flex-row justify-center items-center">
      <app-banner>
        {{ '+USER_DETAILS.BOOKINGS.NO_BOOKINGS' | translate }}
      </app-banner>
    </div>
  </vi-panel>
</ng-container>

<vi-panel *ngIf="!(bookingStore.loaded$ | async)">
  <div content class="flex flex-row justify-center items-center">
    <vi-loader
      data-at-loader
      message="{{ '+USER_DETAILS.BOOKINGS.LOADING_MESSAGE' | translate }}"
      [isLoading]="true"
    ></vi-loader>
  </div>
</vi-panel>
